<template>
    <el-dialog
				:visible.sync="isForm"
				width="50%"
				center
				custom-class="cookie-dialog"
				:before-close="handleClose"
				:close-on-click-modal="true"
				:close-on-press-escape="true"
			>
      <el-form ref="form" :model="formData" size="mini">
        <div class="form-title">{{ $t('content.follow.form.title') }}</div>
        <el-form-item :label="$t('content.follow.form.label.know')" label-position="top">
            <el-select size="100%" v-model="formData.know" :placeholder="$t('error.select')">
                <el-option v-for="value in queryList" :key="value.id" :label="value.name" :value="value.id"></el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$t('content.follow.form.label.identity')" label-position="top">
            <el-select size="100%" v-model="formData.identity" :placeholder="$t('error.select')">
                <el-option v-for="value in $t('content.follow.identityOPtions')" :key="value.value" :label="value.label" :value="value.label"></el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('content.follow.form.label.fullname')" label-position="top">
            <el-input size="100%" v-model="formData.name" placeholder="Enter"></el-input>
        </el-form-item>
        <el-form-item :label="$t('content.follow.form.label.contact')" label-position="top">
            <el-input size="100%" v-model="formData.contact" placeholder="Enter"></el-input>
        </el-form-item>
        <el-form-item :label="$t('content.follow.form.label.email')" label-position="top">
            <el-input size="100%" v-model="formData.email" placeholder="Enter"></el-input>
        </el-form-item>
        <!-- <el-form-item class="form-tip" :label="$t('content.follow.form.label.solve')">
            <el-checkbox-group v-model="formData.type" @change="handleCheckedChange">
                <el-checkbox  v-for="value in checkData" :key="value.value" :label="value.name" :value="value.id" :name="value.name"></el-checkbox>
                
            </el-checkbox-group>
        </el-form-item> -->
        <el-form-item size="large">
            <el-button class="custom-button" type="primary" @click="onSubmit">{{ $t('content.follow.form.buttonText') }}</el-button>
        </el-form-item>
        <!-- <div class="form-remark">{{ $t('content.follow.form.tips') }}</div> -->
      </el-form>
      <!-- <el-checkbox label="发丝枯/断" name="type"></el-checkbox>
                <el-checkbox label="防脱生发" name="type"></el-checkbox> -->
    </el-dialog>
</template>
<script>
import { bus } from '@/utils/bus'
import { getQuestionType,getSolveOption,submitQuestion } from '@/api/komo'
export default {
  name: 'formPc',
  data() {
    return {
      isForm: true,
      queryList: [],
      checkData:[],
      formData: {
        name: '',
        know: '',
        // identity:'',
        contact: '',
        email: '',
        // type: [],
        preferred_city:''
      }
    }
  },
  async created() {
    await this.initData();
  },
  methods: {
    async initData () {
      const result = await getQuestionType();
      this.queryList = result.data.list;
      // const checkList = await getSolveOption()
      // this.checkData = checkList.data.list
    },
    handleClose() {
      this.isForm = false
      bus.$emit('inquiry-form', false)
    },
    handleCheckedChange(value) {
    },
    onSubmit () {
      console.log(this.formData)
      // 校验想知道什么
      if (!this.formData.know) {
				this.$message.error(this.$t('error.select'))
				return;
      }
      // 校验身份
      // if (this.formData.identity ===''|| this.formData.identity == null) {
			// 	this.$message.error(this.$t('error.select'))
			// 	return;
      // }
      // 校验名字
      if (!this.formData.name) {
        this.$message.error(this.$t('error.name'))
				return;
      }
      
      // 校验手机号
      if (!this.formData.contact) {
        this.$message.error(this.$t('error.phone'))
        return;
			}
      if (!this.validatePhone(this.formData.contact)) {
        this.$message.error(this.$t('error.phoneFormat'))
        return;
      }
      
      // 校验邮箱
      if (!this.formData.email) {
        this.$message.error(this.$t('error.email'))
        return;
			} 
      if (!this.validateEmail(this.formData.email)) {
        this.$message.error(this.$t('error.emailFormat'))
        return;
      }
      // 校验checkbox
      // if (!this.formData.type.length) {
      //   this.$message.error(this.$t('error.select'))
      //   return;
      // }
      let params = {
        question_type_id: this.formData.know,
        body_option: "consumer",
        // body_option: this.formData.identity === 0 ? "consumer" : "franchisee",
        full_name: this.formData.name,
        mobile: this.formData.contact,
        email: this.formData.email,
        preferred_city: this.formData.preferred_city,
        // problem: this.formData.type
      }
      submitQuestion(params).then(res => { 
        if (res.error == 0) {
          this.$message.success(res.message);
          this.isForm = false
          bus.$emit('inquiry-form', false)
          //提交成功 重置表单
          this.formData =  {
              name: '',
              know: '',
              // identity:'',
              contact: '',
              email: '',
              // type: [],
              preferred_city:''
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //验证手机号格式
		validatePhone(phone) {
			// 验证手机号是否为纯数字
			const numberRegex = /^1[34578]\d{9}$/;
			return numberRegex.test(phone);
    },
    //验证邮箱格式
    validateEmail(email) {
			const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			return emailRegex.test(email);
		},
  }
}
</script>
<style scoped>
.form-title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #1E1E1E;
    line-height: 42px;
    text-align: center;
    margin: 30px 0;
}

.el-form-item__label {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #252323;
    line-height: 21px;
    padding-right: 0 !important;
}

.el-form-item__content {
    width: 100%;
    height: 56px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
}

.el-select {
    width: 100%;
}

.el-input,
.el-input>input {
    height: 56px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 10px;
}

.form-tip {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #1E1E1E;
    line-height: 21px;
}

.form-remark {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #959595;
    line-height: 21px;
    text-align: left;
    margin-bottom: 1.5vw;
}

.form-tip>>>.el-checkbox__label {
    padding-left: 5px !important;
}

.form-tip>>>.el-checkbox {
    margin-right: 15px !important;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
    border-color: #1e1e1e;
}
:deep(.cookie-dialog){
  border-radius: 30px;
}
:deep(.el-dialog__header){
  padding:0!important;
}
:deep(.el-dialog__body){
  padding:1px 25px 1px!important;
}
:deep(.el-dialog__headerbtn .el-dialog__close){
	font-size: 1vw;
  color: #1e1e1e!important;
}
:deep(.el-button--primary:hover) {
  background: #1e1e1e;
  border-color: #1e1e1e;
  color: #FFF;
}
:deep(.el-button--primary:focus){
  background: #1e1e1e;
  border-color: #1e1e1e;
  color: #FFF;
}
:deep(.el-input.is-active el-input__inner),:deep(.el-input__inner:focus){
  border-color: #aaaaaa;
}
/* el-range-editor.is-active，.el-ramge-editor.i8-active:hover,.el-gelect .el-input.is-focug .elinput imerborder-color:#409EFF */
:deep(.el-checkbox__input.is-checked .el-checkbox__inner),:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner){
  background-color: #1e1e1e;
  border-color: #1e1e1e;
}
:deep(.el-checkbox__label){
  color: #1E1E1E!important;
}
.custom-button {
    background: #1E1E1E;
    border-radius: 10px;
    font-size: 1vw;
    padding: 0.5vw 1.5vw;
    border-color: #1E1E1E;
}
:deep(.el-checkbox__label){
    color: #606266 !important;
    font-weight: 100!important;
    font-size: 1vw!important;
}
:deep(.el-form-item__label){
    font-size: 1vw!important;
    font-family: MicrosoftYaHei;
}
</style>